

export default {
    SET_MENU_LIST(state, payload){
        state.menuList = payload;
    },
    SET_TOTAL(state, payload){
        state.totalRecords = payload
    }
}
